<template>
  <div class="shopping">
    <!-- <div class="row">
      <div class="col shopping-title">Elige opción de compra</div>
    </div> -->
    <div class="row justify-content-between">
      <div class="col-6">
        <CardTotalPayment :meta='meta' />
      </div>
      <div class="col-6">
        <CardPaymentInQuotas :meta='meta' :feePayments="feePayments" @selectFeePayments="selectFeePayments"
          v-if="feePayments" />
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api';
export default {
  name: 'Shopping',
  props:{
    meta:{
      type: Object,
      requerid: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    }
  },
  data() {
    return {
      feePayments: {},
    };
  },
  computed: {
    cartEvents(){
      return this.$store.state.cart.cartEvents;
    }
  },
  methods: {
    async feePayment() {
      const activities = this.cartEvents.map(elem => elem.activityId);
      const activityId = activities.length > 1 ? activities.shift() : activities
      try {
        const payload = {
          amount: Number(this.meta.total),
          activityId: Number(activityId)
        }
        const res = await api.getGenerateFeePayment(payload);
        this.feePayments = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    selectFeePayments(value){
      if (value.length) {
        const feePayments = [];
        value.forEach(element => {
          const obj = {
            amount: element.amount,
            order: element.order,
          }
          feePayments.push(obj)
        });

        if (value.length !== this.feePayments.feePayments.length) {
          this.$store.dispatch('updateFeePayments', feePayments);
        } else {
          this.$store.dispatch('updateFeePayments', []);
        }
        
      } else {
        this.$store.dispatch('updateFeePayments', []);
      }
    }
  },
  mounted() {
    this.feePayment();
  }
};
</script>
<style lang="scss" scoped>
.shopping {
  margin: 1rem 0;

  &-title {
    font-weight: bold;
    font-size: 1.5rem;
    margin: 1rem 0;
  }
}
</style>
